import { atom, useAtom } from "jotai";

import { type KyanWsError } from "#/worker-v2/types/app/messages";
import { ChannelType } from "#/worker-v2/types/protocol/subscriptions";

export type KyanWsErrors = Record<ChannelType, KyanWsError | undefined>;

export const kyanWsErrorsAtom = atom<KyanWsErrors>(
  Object.fromEntries(
    Object.values(ChannelType).map((channel) => [channel, undefined]),
  ) as KyanWsErrors,
);

export const useKyanWsErrors = () => {
  const [kyanWsErrors, setKyanWsErrors] = useAtom(kyanWsErrorsAtom);

  return {
    kyanWsErrors,
    setKyanWsErrors,
  };
};
